import React from 'react';
import { compose } from 'react-apollo';
import { withRouter, RouteComponentProps } from 'react-router';
import {
    user_listUsers_data_product_discounts,
    user_listUsers_data_shipping_discounts,
} from '@api/graphql/types';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { Paths } from '..';
import { DiscountType, DiscountTypeGraphQL } from '../types';

interface Props {
    productDiscounts: user_listUsers_data_product_discounts[] | null;
    shippingDiscounts: user_listUsers_data_shipping_discounts[] | null;
}

interface RouteParams {
    userId: string;
}

type PropType = Props & InjectedIntlProps & RouteComponentProps<RouteParams>;

class UserDiscountList extends React.Component<PropType> {
    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.user.${id}` });
    }

    private onRowClick = (row: user_listUsers_data_product_discounts | user_listUsers_data_shipping_discounts) => () => {
        let discountPath = '';
        const userId: string = this.props.match.params.userId;

        if ((row.__typename === DiscountTypeGraphQL.UserProductDiscount) || (row.__typename === DiscountTypeGraphQL.UserShippingDiscount)) {
            discountPath = (row.__typename === DiscountTypeGraphQL.UserProductDiscount) ? DiscountType.productDiscount : DiscountType.shippingDiscount;
        } else {
            return null;
        }

        return this.props.history.push(`${Paths.user}/${userId}/${discountPath}/${row.id}`);
    }

    private renderTable = (discountType: DiscountType.productDiscount | DiscountType.shippingDiscount, data: Array<user_listUsers_data_product_discounts | user_listUsers_data_shipping_discounts> | null) => {
        return (
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>{this.label(`${discountType}.active_from.title`)}</th>
                        <th>{this.label(`${discountType}.active_to.title`)}</th>
                        <th>{this.label(`${discountType}.is_active.title`)}</th>
                        <th>{this.label(`${discountType}.discount.title`)}</th>
                    </tr>
                </thead>
                <tbody>
                    {(data ? data.map((row: user_listUsers_data_product_discounts | user_listUsers_data_shipping_discounts, index: number): JSX.Element => {
                        return (
                            <tr
                                className="row discountRow"
                                key={`${index}`}
                                style={{ marginBottom: '5px' }}
                                onClick={this.onRowClick(row)}
                            >
                                <td>{row.active_from}</td>
                                <td>{row.active_to}</td>
                                <td>{(row.is_active) ? this.props.intl.formatMessage({ id: 'common.yes' }) : this.props.intl.formatMessage({ id: 'common.no' })}</td>
                                <td>{(row.discount) ? `${row.discount}%` : ''}</td>
                            </tr>
                        );
                    }) : null)}
                </tbody>
            </table>
        );
    }

    public render() {
        const userId: string = this.props.match.params.userId;
        const { history, intl, productDiscounts, shippingDiscounts } = this.props;

        return userId && (
            <>
                <div className="row userDiscountListHeader">
                    <div className="pull-right">
                        <button
                            className="btn btn-primary"
                            onClick={(e: React.SyntheticEvent) => history.push(`${Paths.user}/${userId}/product-discounts${Paths.discountsCreate}`)}
                        >
                            <i className="fa fa-plus" />
                            {this.label('product-discounts_create')}
                        </button>
                    </div>
                    <h3>{intl.formatMessage({ id: "module.user.product-discounts.title" })}</h3>
                </div>
                {(productDiscounts && productDiscounts.length > 0)
                    ? this.renderTable(DiscountType.productDiscount, productDiscounts)
                    : intl.formatMessage({ id: 'component.dataTable.noData' })
                }
                <hr />
                <div className="row userDiscountListHeader">
                    <div className="pull-right">
                        <button
                            className="btn btn-primary"
                            onClick={(e: React.SyntheticEvent) => history.push(`${Paths.user}/${userId}/shipping-discounts${Paths.discountsCreate}`)}
                        >
                            <i className="fa fa-plus" />
                            {this.label('shipping-discounts_create')}
                        </button>
                    </div>
                    <h3>{intl.formatMessage({ id: "module.user.shipping-discounts.title" })}</h3>
                </div>
                {(shippingDiscounts && shippingDiscounts.length > 0)
                    ? this.renderTable(DiscountType.shippingDiscount, shippingDiscounts)
                    : intl.formatMessage({ id: 'component.dataTable.noData' })
                }
            </>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(UserDiscountList);


// WEBPACK FOOTER //
// ./src/modules/User/components/UserDiscountList.tsx